import { PureComponent, Fragment } from 'react'
import styled from 'glamorous'
import { Loader } from 'components'
import { $ } from 'utils'

const Button = styled.button({
  position: 'absolute',
  left: 0,
  bottom: 0,
  height: 75,
  width: '100%',
  backgroundColor: 'var(--lightestGrey)',
  border: 'none',
  userSelect: 'none',
  transition: 'var(--transition)',
  color: 'white',
  zIndex: 2,
  '&:hover': {
    backgroundColor: 'var(--lightestGrey)',
  }
}, ({ disabled }) => !disabled && ({
  background: 'var(--green)',
  cursor: 'pointer',
  '&:hover': {
    background: 'var(--green)',
  }
}))

const Text = styled.div({
  fontSize: 20,
  color: 'var(--white)',
})

const ValueText = styled.div({
  fontSize: 14,
  color: 'var(--white)',
  opacity: '.9',
})

class FlatButton extends PureComponent {

  state = {
    isLoading: false
  }

  reset = () => {
    this.setState({ isLoading: false })
  }

  handleClick = (e) => {
    if (typeof this.props.onClick === 'function') {
      this.setState({ isLoading: true })

      const promise = this.props.onClick()
      if (promise && promise.then !== undefined) {
        promise
          .then(() => this.reset())
          .catch(() => this.reset())
      } else {
        this.reset()
      }
    }
  }

  render() {
    const { text, valueText, disabled, onClick, ...props } = this.props
    const { isLoading } = this.state
    return (
      $(Button, {
        disabled: disabled || isLoading,
        onClick: e => this.handleClick(e),
        ...props
      },
        !isLoading
          ? $(Fragment,
              $(Text, text),
              $(ValueText, valueText)
            )
          : $(Loader, { size: 30, style: { opacity: .7 } })
      )
    )
  }
}

export default FlatButton



// WEBPACK FOOTER //
// ./src/components/FlatButton.js